import React, { useEffect } from 'react';
import Modal from 'antd/lib/modal/Modal';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Divider,
  Form,
  Input,
  Layout,
  Select,
  Spin
} from 'antd';

const { Option } = Select;

const EmailModal = ({
  name,
  subject,
  onConfirm,
  onClose,
  content,
  courses,
  selectedCourseOffer,
  courseOffers,
  selectedLearner,
  learners,
  fetching,
  hasAttachment,
  sendEmailToAllInCourse,
  setSendEmailToAllInCourse,
  statusList,
  setStatusList
}) => {
  useEffect(() => {
    courses.fetch();
  }, []);

  const renderStatusListOption = () => {
    return [
      'Pending',
      'Current',
      'Withdrawn',
      'Inactive',
      'Cancelled',
      'Transferred'
    ].map((option, index) => (
      <Option value={option} key={index}>
        {option}
      </Option>
    ));
  };

  return (
    <Modal
      visible={true}
      onCancel={onClose}
      onOk={onConfirm}
      title={`Edit Email Template - ${name}`}
      centered={true}
      okText="Send Email">
      <Form>
        <Form.Item label="Course*">
          <Select
            mode={''}
            placeholder="Search courses"
            disabled={fetching}
            options={courses.data}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            filterOption={false}
            showSearch={true}
            onSearch={courses.filter}
            onChange={(value) => {
              courses.onChange(value);
            }}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item label="Course Offer*">
          <Select
            mode={''}
            disabled={
              courseOffers.data.length === 0 ? true : false || fetching
            }
            placeholder="Search course offers"
            value={selectedCourseOffer}
            options={courseOffers.data}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            filterOption={false}
            showSearch={true}
            onSearch={courseOffers.filter}
            onChange={(value) => {
              courseOffers.onChange(value);
            }}
            style={{ width: '100%' }}
          />
        </Form.Item>
        {selectedCourseOffer ? (
          <Form.Item>
            <Checkbox
              checked={sendEmailToAllInCourse}
              disabled={!selectedCourseOffer}
              onChange={() =>
                setSendEmailToAllInCourse(!sendEmailToAllInCourse)
              }>
              Send to All students in course offer
            </Checkbox>
          </Form.Item>
        ) : null}
        {sendEmailToAllInCourse && selectedCourseOffer ? (
          <Form.Item name="statusList" label="Select student status*">
            <Select
              placeholder="Select student status"
              defaultValue={['Pending', 'Current']}
              mode="multiple"
              disabled={!sendEmailToAllInCourse}
              onChange={(value) => {
                setStatusList(value);
              }}>
              {renderStatusListOption()}
            </Select>
          </Form.Item>
        ) : null}
        <Form.Item label="Learner*">
          <Select
            mode="multiple"
            disabled={
              learners.data.length === 0 || sendEmailToAllInCourse
                ? true
                : false || fetching
            }
            placeholder="Search learners"
            value={selectedLearner}
            options={learners.data}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            filterOption={false}
            showSearch={true}
            onSearch={learners.filter}
            onChange={(value) => {
              learners.onChange(value);
            }}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item label="Subject">
          <Input value={subject} disabled />
        </Form.Item>
        <Form.Item>
          <Checkbox checked={hasAttachment} disabled>
            With Attachment
          </Checkbox>
        </Form.Item>
      </Form>
      <Divider />
      <div>
        <Divider />
        <h1>Email Template Preview</h1>
        <Layout
          style={{
            background: 'rgb(251, 251, 251)',
            border: '1px solid black'
          }}>
          <iframe
            src={content}
            title={name}
            height="300"
            className=""
            title="Rich Text Editor, editor1"
            aria-describedby="cke_57"
            tabIndex="0"
            allowtransparency="true"
            frameBorder="0"
          />
        </Layout>
      </div>
    </Modal>
  );
};

const InputPropTypesShape = {
  fetch: PropTypes.func,
  filter: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.array
};

EmailModal.propTypes = {
  name: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  courses: PropTypes.shape(InputPropTypesShape).isRequired,
  selectedCourseOffer: PropTypes.number,
  courseOffers: PropTypes.shape(InputPropTypesShape).isRequired,
  selectedLearner: PropTypes.array,
  learners: PropTypes.shape(InputPropTypesShape).isRequired,
  fetching: PropTypes.bool.isRequired,
  hasAttachment: PropTypes.bool,
  sendEmailToAllInCourse: PropTypes.bool,
  setSendEmailToAllInCourse: PropTypes.func,
  statusList: PropTypes.array,
  setStatusList: PropTypes.bool
};

export default EmailModal;
